export default __webpack_public_path__ + "static/media/Tokenization Platform.ebfcd45b.png";